import Hero from '../components/Hero';
import Features from '../components/Features';
import WhyQuickTL from '../components/WhyQuickTL';
import HowItWorks from '../components/HowItWorks';
import Pricing from '../components/Pricing';
import CTA from '../components/CTA';

export default function Home() {
  return (
    <>
      <Hero />
      <Features />
      <WhyQuickTL />
      <HowItWorks />
      <Pricing />
      <CTA />
    </>
  );
}
